/**
 * Sticky Add-to-Cart Manager
 * Handles scroll-based visibility for sticky add-to-cart elements
 */

// Prevent duplicate class declarations
if (typeof window.StickyCartManager === 'undefined') {

  window.StickyCartManager = class StickyCartManager {

    constructor() {

      return;

      if (typeof ScrollMagic === "undefined") {
        var s = document.createElement("script");
        s.src = "https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.8/ScrollMagic.min.js";
        document.head.appendChild(s);
        s.onload = initScrollMagic;
      } else {
        initScrollMagic();
      }

      function initScrollMagic() {
        const controller = new ScrollMagic.Controller();
        const sticky = document.querySelector(".sticky-add-to-cart");
        new ScrollMagic.Scene({
          triggerElement: ".product__custom-add-to-cart.main",
          triggerHook: 0, // top of viewport
        })
          .on("enter", function (event) {
            sticky.classList.add("sticky-cart-visible");
          })
          .on("leave", function (event) {
            if (event.scrollDirection === "FORWARD") {
              // console.log("⬆️ Button scrolled past the top (disappeared)");
            } else {
              sticky.classList.remove("sticky-cart-visible");
            }
          })
          .addTo(controller);
      }

    }

  };

  // Initialize the sticky cart manager
  window.stickyCartManager = new window.StickyCartManager();
}